import * as vp from 'vopay';
import { Table, Box, SubTitle, Badge } from 'vopay';
import { FunctionComponent } from 'react';

type InteracMoneyRequestTransactionInfoProps = {
  transaction: vp.InteracTransactionResponse;
};

type FC = FunctionComponent<InteracMoneyRequestTransactionInfoProps>;

type KeyValuePair = {
  display: string;
  value: string | React.JSX.Element;
};

type TablePropsHandlers = {
  transaction: () => vp.TableProps;
};

const InteracMoneyRequestTransactionInfo: FC = ({ transaction }) => {
  return (
    <div>
      <Box mt="lg" mb="md">
        <SubTitle subTitle="Transaction Detail" />
      </Box>
      <Table {...getTableProps('transaction')} />
    </div>
  );

  function getTableProps(handler: keyof TablePropsHandlers): vp.TableProps {
    const handlers: TablePropsHandlers = {
      transaction: () => {
        const accountDetailPairs: KeyValuePair[] = [
          {
            display: 'Transaction ID',
            value: transaction.TransactionID,
          },
          {
            display: 'Transaction Status',
            value: (
              <Badge
                label={vp.capitalizeFirstLetter(transaction.TransactionStatus ?? '')}
                hasIcon
                color={vp.GetColorStatus(transaction.TransactionStatus)}
              />
            ),
          },
          {
            display: 'Failure Reason',
            value: transaction.FailureReason,
          },
          {
            display: 'Transaction Date Time',
            value: transaction.TransactionDateTime,
          },
          {
            display: 'Amount',
            value: transaction.Amount,
          },
          {
            display: 'Currency',
            value: transaction.Currency,
          },
          {
            display: 'Hold Amount',
            value: transaction.HoldAmount,
          },
          {
            display: 'Last Modified',
            value: transaction.LastModified,
          },
          {
            display: 'Name',
            value: transaction.Name,
          },
          {
            display: 'Email',
            value: transaction.Email,
          },
          {
            display: 'Phone Number',
            value: transaction.PhoneNumber,
          },
          {
            display: 'Recipient Name',
            value: transaction.RecipientName,
          },
          {
            display: 'Message For Recipient',
            value: transaction.MessageForRecipient,
          },
          {
            display: 'Client Reference Number',
            value: transaction.ClientReferenceNumber,
          },
          {
            display: 'Confirmation Number',
            value: transaction.ConfirmationNumber,
          },
          {
            display: 'Processing Date',
            value: transaction.ProcessingDate,
          },
        ];

        const accountInfoProps: vp.TableProps = {
          name: 'transaction-details',
          variant: 'pair',
          columns: {
            detailKey: { header: 'Transaction Detail' },
            detailValue: { header: '' },
          },
          rows: accountDetailPairs.map(({ display, value }) => ({
            detailKey: display,
            detailValue: value,
          })),
        };

        return accountInfoProps;
      },
    };

    return handlers[handler]();
  }
};

export default InteracMoneyRequestTransactionInfo;
